import { SURVEY_YEAR, getOrderedKpiDefinitions } from "../kpiConfiguration";
import { toFiniteNumber } from "./kpiFormatters";

// The request returns an envelope; page state stores its data property.
function getEndpointPayload(data) {
  return data?.data ?? data;
}

export function getSelectedBusinessKeyFigures(data) {
  const payload = getEndpointPayload(data);

  return payload?.reportData?.businessKeyFigures?.find((group) => group.period === SURVEY_YEAR) ?? { period: null, keyFigures: [] };
}

export function getKeyFiguresCurrency(data) {
  return getEndpointPayload(data)?.context?.unit || "CHF";
}

export function parseKpiScoreCardData(data, translate, group = "major") {
  const selectedGroup = getSelectedBusinessKeyFigures(data);

  return getOrderedKpiDefinitions(translate, group)
    .map((definition) => {
      const raw = selectedGroup.keyFigures.find((figure) => figure.keyFigure === definition.keyFigure);

      if (!raw && group !== "minor") return null;

      const sd = toFiniteNumber(raw?.metrics?.stddev);

      return {
        ...definition,
        period: selectedGroup.period,
        mean: toFiniteNumber(raw?.metrics?.mean),
        sd: sd !== null && sd >= 0 ? sd : null,
        respondentValue: toFiniteNumber(raw?.companyValue),
        quality: raw?.metrics?.quality ?? null,
      };
    })
    .filter(Boolean);
}
